export default [
  {
    id: 'cp001',
    nameKey: 'products.cp001.name',
    bannerList: [
      {
        titleKey: 'products.cp001.banner.title',
        descKey: 'products.cp001.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-01.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp001.features.antiViolation.title',
        descKey: 'products.cp001.features.antiViolation.desc',
        image: require('@/assets/img/Products/产品中心-AI融合管理平台-反三违.jpg'),
      },
      {
        titleKey: 'products.cp001.features.mainTransport.title',
        descKey: 'products.cp001.features.mainTransport.desc',
        image: require('@/assets/img/Products/产品中心-AI融合管理平台-主辅运输.png'),
      },
      {
        titleKey: 'products.cp001.features.scraper.title',
        descKey: 'products.cp001.features.scraper.desc',
        image: require('@/assets/img/Products/产品中心-AI融合管理平台-异常报警.png'),
      },
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.intelligentDispatch.title',
        descKey: 'home.cases.intelligentDispatch.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Home/case/case01.jpg")
      }
    ]
  },
  {
    id: 'cp002',
    nameKey: 'products.cp002.name',
    bannerList: [
      {
        titleKey: 'products.cp002.banner.title',
        descKey: 'products.cp002.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-AI设备专家平台.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp002.features.management.title',
        descKey: 'products.cp002.features.management.desc',
        image: require('@/assets/img/Products/产品中心-AI设备专家-设备管理.jpg'),
      },
      {
        titleKey: 'products.cp002.features.analysis.title',
        descKey: 'products.cp002.features.analysis.desc',
        image: require('@/assets/img/Products/产品中心-AI设备专家-故障分析.png'),
      },
      {
        titleKey: 'products.cp002.features.report.title',
        descKey: 'products.cp002.features.report.desc',
        image: require('@/assets/img/Products/产品中心-AI设备专家-数据管理.png'),
      },
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.predictiveMaintenance.title',
        descKey: 'home.cases.predictiveMaintenance.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Products/case/产品中心-AI设备专家平台-case.png")
      }
    ]
  },
  {
    id: 'cp003',
    nameKey: 'products.cp003.name',
    bannerList: [
      {
        titleKey: 'products.cp003.banner.title',
        descKey: 'products.cp003.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-问煤.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp003.features.regulation.title',
        descKey: 'products.cp003.features.regulation.desc',
        image: require('@/assets/img/Products/产品中心-问煤-行业法规秒级检索.png'),
      },
      {
        titleKey: 'products.cp003.features.standard.title',
        descKey: 'products.cp003.features.standard.desc',
        image: require('@/assets/img/Products/产品中心-问煤-标准化作业指导.jpg'),
      },
      {
        titleKey: 'products.cp003.features.multiSource.title',
        descKey: 'products.cp003.features.multiSource.desc',
        image: require('@/assets/img/Products/产品中心-问煤-多源输入支持.jpg'),
      },
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.safetyAssistant.title',
        descKey: 'home.cases.safetyAssistant.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Products/case/产品中心-问煤-case.png")
      }
    ]
  },
  {
    id: 'cp004',
    nameKey: 'products.cp004.name',
    bannerList: [
      {
        titleKey: 'products.cp004.banner.title',
        descKey: 'products.cp004.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-井下智能防爆终端.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp004.features.localCompute.title',
        descKey: 'products.cp004.features.localCompute.desc',
        image: require('@/assets/img/Products/产品中心-井下智能防爆终端-本地化算力赋能.jpg'),
      },
      {
        titleKey: 'products.cp004.features.alarm.title',
        descKey: 'products.cp004.features.alarm.desc',
        image: require('@/assets/img/Products/产品中心-井下智能防爆终端-实时声光报警.png'),
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.edgeResponse.title',
        descKey: 'home.cases.edgeResponse.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Products/case/产品中心-井下智能防爆终端-case.png")
      }
    ]
  },
  {
    id: 'cp005',
    nameKey: 'products.cp005.name',
    bannerList: [
      {
        titleKey: 'products.cp005.banner.title',
        descKey: 'products.cp005.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-液压支架辅助安装机器人.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp005.features.robotReplace.title',
        descKey: 'products.cp005.features.robotReplace.desc',
        image: require('@/assets/img/Products/产品中心-液压支架辅助安装机器人-降本增效提安.png'),
      },
      {
        titleKey: 'products.cp005.features.autoInspect.title',
        descKey: 'products.cp005.features.autoInspect.desc',
        image: require('@/assets/img/Products/智能巡检自主运行.png'),
      },
      {
        titleKey: 'products.cp005.features.aiPerceive.title',
        descKey: 'products.cp005.features.aiPerceive.desc',
        image: require('@/assets/img/Products/AI感知与协同联动.png'),
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.unmannedInstallation.title',
        descKey: 'home.cases.unmannedInstallation.desc',
        effectKey: '',
        evaluationKey: '',
        image: require('@/assets/img/Products/产品中心-液压支架辅助安装机器人-降本增效提安.png'),
      }
    ]
  },
  {
    id: 'cp006',
    nameKey: 'products.cp006.name',
    bannerList: [
      {
        titleKey: 'products.cp006.banner.title',
        descKey: 'products.cp006.banner.desc',
        btnText: '',
        image: require('@/assets/img/Products/banner/banner-煤矿私有化智能助手.webp'),
        link: '/about',
        bottomTextsKey: 'home.banner.aiEngine.tags'
      }
    ],
    CoreFeaturesList: [
      {
        titleKey: 'products.cp006.features.docReport.title',
        descKey: 'products.cp006.features.docReport.desc',
        image: require('@/assets/img/Products/产品中心-Coalclaw 煤矿私有化智能助手-公文与报表自动化.jpg'),
      },
      {
        titleKey: 'products.cp006.features.taskManage.title',
        descKey: 'products.cp006.features.taskManage.desc',
        image: require('@/assets/img/Products/产品中心-Coalclaw 煤矿私有化智能助手-智能任务督办.jpg'),
      }
    ],
    CustomerCaseList: [
      {
        titleKey: 'home.cases.officeAutomation.title',
        descKey: 'home.cases.officeAutomation.desc',
        effectKey: '',
        evaluationKey: '',
        image: require("@/assets/img/Products/case/产品中心-Coalclaw私有化智能助手-case.png")
      }
    ]
  },
]